import TypingContainer from './TypingContainer';

export default TypingContainer;
